import '@mantine/core/styles.css';

import { StrictMode } from 'react';

import createShadowDomRoot from '../common/utils/create-shadow-dom-root';
import ScaledMantineProvider from '../common/utils/scaled-mantine-provider';
import InstallPage from './install-page';

const rootId = 'ai_editor_install';

if (!document.getElementById(rootId)) {
  console.log(`No element with id "${rootId}" found`);
} else {
  const { reactRoot, shadowContainer } = await createShadowDomRoot(rootId);
  reactRoot.render(
    <StrictMode>
      <ScaledMantineProvider shadowContainer={shadowContainer}>
        <InstallPage />
      </ScaledMantineProvider>
    </StrictMode>,
  );
}
